// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fieldsStack {
    gap: 2rem;
    margin: 2rem 5rem 0;
}

.fieldsStack__field {
    min-width: 300px;
    max-width: 100%;
}

.fieldsStack__field__input {
    text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/pages/consulteeUserSettings/ConsulteeUserSettings.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".fieldsStack {\n    gap: 2rem;\n    margin: 2rem 5rem 0;\n}\n\n.fieldsStack__field {\n    min-width: 300px;\n    max-width: 100%;\n}\n\n.fieldsStack__field__input {\n    text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
